<template>
	<div
		class="view view-not-found"
	>
		<banner />

		<div
			class="main-content main-content--max-width main-content--spaced-top"
		>
			<div class="container">
				<h1 class="content-title">Sorry, the requested content has not been found</h1>

				<hr class="hr--small" />

				<div class="introduction">
					You can try searching or selecting a topic.
				</div>

				<button
					type="button"
					@click="$store.commit('modalVisible', { modal: 'chooseTopic', boolean: true })"
					class="btn--tertiary btn--full btn--tall btn--centered"
				>
					Select a topic
				</button>

			</div>

		</div>

	</div>
</template>

<script>
// Components
import Banner from '@/components/blocks/Banner.vue';

export default {
	components: {
		Banner
	},
	watch: {
		// Reset state when route changed
		$route() {
			this.$store.commit('contentNotFound', false);
		}
	},
};
</script>